import { render, staticRenderFns } from "./header-basket.vue?vue&type=template&id=8b0d4076&"
import script from "../../js/widgets/header-basket.js?vue&type=script&lang=js&"
export * from "../../js/widgets/header-basket.js?vue&type=script&lang=js&"
import style0 from "./header-basket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports